/* eslint-disable */

import { useRecoilState, useRecoilValueLoadable } from 'recoil'
import { MutualFundsSIPs } from '../../store/MFStore'
import { useEffect, useState, useRef } from 'react'
import { Button } from '../../Components/ui/button'
import MFOrdersSkeleton from '../../Components/SkeletonLoaders/MFOrdersSkeleton'
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '../../Components/ui/accordian'
import env from '../../env/env'
import { toCurrency, formatIndianCurrency } from '../../utils/CurrencyUtil'
import {
  addMonthForModifySIP,
  addNumberSuffix,
  capitalizeWords,
  cleanIndianPhoneNumber,
  monthShortNames,
} from '../../utils/Util'
import { MoreVerticalIcon, Pen } from 'lucide-react'

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from '../../Components/ui/menubar'
import { Separator } from '../../Components/ui/separator'
import { post } from '../../http/restservice'
import { userDetailsState } from '../LoginState'
import { useModal } from '../../hooks/use-modal-store'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../Components/ui/dialog'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../../Components/ui/sheet'
import useMediaQuery from '../../hooks/useMediaQuery'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Components/ui/select'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs2'
import SIPsEmpty from '../../Components/EmptyState/SIPsEmpty'
import OrderOtpVerification from '../../Pages/MutualFundsBaskets/OrderOtpVerification'
import { Input } from '../../Components/ui/input'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import { CalendarIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import ApiErrorState from '../../Components/Errors/ApiErrorState'
import basketRowIcon from '../../assets/SVGS/fabits-basket-row-icon.svg'
import { Skeleton } from '../../Components/ui/skeleton'
import {
  getSipStatusLabel,
  isActiveSipStatus,
  isInactiveSipStatus,
} from '../../utils/SipStatusUtil'

const INACTIVE_PAGE_SIZE = 5

const parseSipDate = (dateString) => {
  if (!dateString) return 0

  const normalizedDate = String(dateString).trim().replace('T', ' ')
  const [datePart] = normalizedDate.split(/\s+/)
  const delimiter = datePart.includes('/') ? '/' : '-'
  const parts = datePart.split(delimiter).map(Number)

  if (parts.length === 3 && parts.every((part) => !Number.isNaN(part))) {
    const [first, second, third] = parts
    const [year, month, day] =
      String(first).length === 4 ? [first, second, third] : [third, second, first]
    return new Date(year, month - 1, day).getTime()
  }

  const parsedDate = Date.parse(dateString)
  return Number.isNaN(parsedDate) ? 0 : parsedDate
}

const BasketSIPs = () => {
  const navigate = useNavigate()
  const sips = useRecoilValueLoadable(MutualFundsSIPs)
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)
  const isDesktop = useMediaQuery('(min-width: 768px)')
  const [selectedDay, setSelectedDay] = useState(5)
  const sipDates = [3, 5, 10, 15, 22, 25]
  const [sipDate, setSipDate] = useState('')
  const [activeSips, setActiveSips] = useState(null)
  const [inProgressSips, setInProgressSips] = useState(null)
  const [cancelledSips, setCancelledSips] = useState(null)
  const [cancelledSipsCount, setCancelledSipsCount] = useState(0)
  const [activeSipsCount, setActiveSipsCount] = useState(0)
  const [inProgressSipsCount, setInProgressSipsCount] = useState(0)
  const [visibleOlderInactiveCount, setVisibleOlderInactiveCount] = useState(0)
  const [loadingMoreInactive, setLoadingMoreInactive] = useState(false)
  const [openMenubar, setOpenMenubar] = useState(null)
  const [userDetails, setUserDetails] = useRecoilState(userDetailsState)
  const userData = JSON.parse(localStorage.getItem('userData'))
  const clientCode = userDetails ? userDetails?.uid?.split('-')[0] : userData?.uid?.split('-')[0]
  const email = userDetails?.email || userData?.email
  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const [showSIPCancel, setShowSIPCancel] = useState(false)
  const [selectedReason, setSelectedReason] = useState('')
  const [selectedSIP, setSelectedSIP] = useState([])
  const [openOTPPopup, setOpenOTPPopup] = useState(false)
  const [showSIPUpdate, setShowSIPUpdate] = useState(false)
  const [selectedSIPUpdate, setSelectedSIPUpdate] = useState(null)
  const [selectedAmount, setSelectedAmount] = useState('')
  const [selectedAmountDisplay, setSelectedAmountDisplay] = useState('')
  const [otpActionType, setOtpActionType] = useState(null) // 'cancel' or 'update'
  const [isDatePopoverOpen, setIsDatePopoverOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const skipAmountResetRef = useRef(false)

  const currentDate = new Date()
  const today = currentDate.getDate()

  useEffect(() => {
    const res = addMonthForModifySIP(today, selectedDay)
    setSipDate(res)
  }, [selectedDay, today])

  useEffect(() => {
    if (sips?.state === 'hasValue' && sips?.contents?.data?.length > 0) {
      const groupedSIPs = sips?.contents?.data?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId && isActiveSipStatus(sip.sipStatus)) {
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []
          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setActiveSips(groupedSIPs)
    }

    if (sips?.state === 'hasValue' && sips?.contents?.inProgressSipData?.length > 0) {
      // Flatten logic
      const flattenedSIPs = sips?.contents?.inProgressSipData?.flatMap((sipObj) =>
        sipObj.orderRequest?.sipData?.map((sip) => ({
          ...sipObj, // copy parent keys (like customerBasketInvestmentId, orderType, etc.)
          ...sipObj.orderRequest, // copy orderRequest keys
          ...sip, // copy individual SIP keys
        })),
      )

      // Remove nested arrays if not needed
      const result = flattenedSIPs?.map(({ sipData, orderRequest, ...rest }) => rest)

      setInProgressSipsCount(result?.length)

      const groupedSIPs = result?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId) {
          // Initialize the array for this basket
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []

          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setInProgressSips(groupedSIPs)
    }

    if (sips?.state === 'hasValue' && sips?.contents?.data?.length > 0) {
      const groupedSIPs = sips?.contents?.data?.reduce((acc, sip) => {
        if (sip.customerBasketInvestmentId && isInactiveSipStatus(sip.sipStatus)) {
          acc[sip.customerBasketInvestmentId] = acc[sip.customerBasketInvestmentId] || []
          acc[sip.customerBasketInvestmentId].push(sip)
        }
        return acc
      }, {})

      setCancelledSips(groupedSIPs)
      setVisibleOlderInactiveCount(0)
    }
  }, [sips])

  const handleSelectedAmountChange = (e) => {
    const inputValue = e.target.value
    // Remove all <non-d></non-d> digit characters (including commas)
    const numericValue = inputValue.replace(/[^0-9]/g, '')

    // Format in Indian currency format with commas
    const formattedValue = numericValue ? formatIndianCurrency(numericValue) : ''

    setSelectedAmountDisplay(formattedValue)

    // Store numeric value for calculations
    if (numericValue && !isNaN(numericValue) && Number(numericValue) >= 0) {
      setSelectedAmount(Number(numericValue))
    } else if (!numericValue) {
      setSelectedAmount('')
    }
  }

  const cancellationReasons = [
    { code: '09', description: 'Will restart SIP in a few months' },
    { code: '13A', description: 'Plan revised' },
    { code: '07', description: 'Goal Achieved' },
    { code: '01', description: 'Insufficient funds' },
    // { code: '02', description: 'Scheme not performing' },
    // { code: '03', description: 'Service issue' },
    // { code: '04', description: 'Load Revised' },
    // { code: '05', description: 'Wish to invest in other schemes' },
    // { code: '06', description: 'Change in Fund Manager' },

    // { code: '08', description: 'Not comfortable with market volatility' },

    // { code: '10', description: 'Modifications in bank/mandate/date etc' },
    // { code: '11', description: 'I have decided to invest elsewhere' },
    // { code: '12', description: 'This is not the right time to invest' },
    { code: '13', description: 'Others' },
  ]

  const generateOTP = async () => {
    setLoading(true)
    try {
      const response = await post(
        `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
        {
          phoneNumber: userDetails?.phoneNumber,
          email: email.includes('fabits') ? '' : email,
        },
      )

      if (response.isError) {
        showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => { })
        return false
      }

      // Always dismiss the reason/update modal before showing OTP,
      // so OTP is never trapped under the previous dialog overlay.
      setShowSIPCancel(false)
      if (otpActionType === 'update' || otpActionType === 'restart') {
        setShowSIPUpdate(false)
      }
      setOpenOTPPopup(true)
      return true
    } finally {
      setLoading(false)
    }
  }

  const openSipUpdateBreakdown = async () => {
    if (!selectedAmount || Number(selectedAmount) <= 0) {
      showError('Invalid Amount', 'Please enter a valid amount to update your SIP.', () => { })
      return
    }

    if (otpActionType !== 'update') {
      await generateOTP()
      return
    }

    const constituents = getNewSipBreakdown(selectedSIPUpdate, selectedAmount)

    if (!constituents?.length) {
      showError(
        'SIP update failed',
        'Unable to build the fund breakdown. Please try again later or contact support.',
        () => { },
      )
      return
    }

    skipAmountResetRef.current = true
    setShowSIPUpdate(false)

    onOpen('sipBreakdown', {
      constituents,
      totalAmount: Number(selectedAmount),
      confirmLabel: 'Confirm',
      onConfirm: () => generateOTP(),
    })
  }



  const handleSIPCancel = async () => {
    setOpenMenubar(null)

    const payload = {
      clientCode: clientCode?.toUpperCase(),
      registrationNumberList: selectedSIP?.map((sip) => sip.sipRegId),
      sipCancelReason: selectedReason?.replace(/\D/g, '')?.toString(),
    }

    const response = await post(`mutualfundservice/api/basket/multiBasketSipCancellation`, payload)

    const isAllSuccess = response?.basketSipCancellationResponse?.every(
      (item) => item.status === 'SUCCESS',
    )

    if (!response?.isError && isAllSuccess) {
      setShowSIPCancel(false)

      onOpen('openSIPPopup', {
        title: 'Cancellation Successful',
        message: 'Your cancellation has been completed successfully.',
        severity: 'success',
      })

      setSelectedReason('')
    } else if (!response?.isError && !isAllSuccess) {
      showError(
        'SIP cancellation failed',
        'We were unable to initiate your SIP cancellation request. Please try again later or contact support if the issue persists.',
        () => { },
      )
      setSelectedReason('')
    }

    if (response?.isError) {
      showError(
        'SIP cancellation failed',
        'We were unable to initiate your SIP cancellation request. Please try again later or contact support if the issue persists.',
        () => { },
      )
      setSelectedReason('')
    }
  }

  const handleSIPUpdate = async () => {
    if (!selectedAmount || Number(selectedAmount) <= 0) {
      showError('Invalid Amount', 'Please enter a valid amount to update your SIP.', () => { })
      return
    }

    await handleNewSIPRegistration()
  }

  const handleSIPRestart = async () => {
    if (!selectedAmount || Number(selectedAmount) <= 0) {
      showError('Invalid Amount', 'Please enter a valid amount to restart your SIP.', () => { })
      return
    }

    fetchMandateDetails()
  }

  const getNewSipBreakdown = (selectedPlan, totalAmount) => {
    const universalBasketId = selectedPlan[0].universalBasketId
    const basketFunds =
      baskets?.state === 'hasValue'
        ? baskets?.contents?.data?.filter((plan) => plan.universalBasketId === universalBasketId) ||
        []
        : []
    const currentBasketVersion = basketFunds[0]?.versionNumber
    const existingBreakdown = selectedPlan || []
    const referenceSip = existingBreakdown[0]

    const newUpdatedPlan = basketFunds
      .filter((fund) => fund.weightage > 0)
      .map((fund) => (
        {
          schemeCode: fund.bseSchemeCode,
          schemeName: fund.schemeName,
          amcCode: fund.amcCode,
          installmentAmt: (totalAmount / 100) * fund.weightage,
          currentBasketVersion,
          sipStartDate: referenceSip?.sipStartDate,
          customerBasketInvestmentId: selectedPlan.customerBasketInvestmentId,
          customerBasketName: referenceSip?.customerBasketName,
        }
      ))

    return newUpdatedPlan
  }



  const handleNewSIPRegistration = async () => {
    setLoading(true)

    try {
      const newBasketDistribution = getNewSipBreakdown(selectedSIPUpdate, selectedAmount)


      if (!newBasketDistribution?.length) {
        showError(
          'SIP update failed',
          'Unable to update your SIP. Please try again later or contact support.',
          () => { },
        )
        return
      }

      const newBasketDistributionPayload = newBasketDistribution.map((item) => ({
        schemeCode: item.schemeCode,
        installmentAmount: item.installmentAmt,
      }))

      const payload = {
        clientCode: clientCode?.toUpperCase(),
        mandateId: selectedSIPUpdate[0]?.mandateId,

        currentBasketSips: selectedSIPUpdate?.map((item) => ({
          schemeCode: item.schemeCode,
          folioNumber: item.folioNo,
          sipRegId: item.sipRegId,
        })),

        newBasketDistribution: newBasketDistributionPayload,
        customerBasketInvestmentId: selectedSIPUpdate[0]?.customerBasketInvestmentId,
        phoneNumber: cleanIndianPhoneNumber(userDetails?.phoneNumber),
        startDate: addMonthForModifySIP(5, newBasketDistribution[0]?.sipStartDate?.split('/')[0]),
        isRebalanceUpdate: false,
        currentBasketVersion: newBasketDistribution[0]?.currentBasketVersion,
      }

      const updateSIP = await post(`mutualfundservice/api/basket/sipUpdate`, payload)

      if (updateSIP?.isError) {
        showError(
          'SIP update failed',
          'We were unable to update your SIP. Please try again later or contact support if the issue persists.',
          () => { },
        )
        return
      }

      if (updateSIP?.status === 'SUCCESS') {
        onOpen('openSIPPopup', {
          title: 'SIP update successful',
          message: 'Your SIP has been updated successfully.',
          severity: 'success',
        })
      }
    } finally {
      setLoading(false)
    }
  }

  const calculateParcentage = (part, total) => {
    const result = (part / total) * 100
    return result ? parseFloat(result.toFixed(2)) : 0
  }

  const getTotalAmount = (sips) => {
    const sipTotal =
      sips?.reduce((acc, sip) => acc + Number(sip.installmentAmt || sip.installmentAmount), 0) || 0

    return sipTotal
  }

  const getDate = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[0]
  }

  const getMonth = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[1]
  }

  const getYear = (dateString) => {
    if (!dateString) return null // Handle null/undefined cases

    // Determine the correct delimiter
    const delimiter = dateString.includes('/') ? '/' : '-'

    return dateString.split(delimiter)[2]
  }

  const getActiveSipsInfo = (sips = []) => {
    return sips
      ?.filter((sip) => sip.customerBasketInvestmentId !== null)
      ?.reduce(
        (acc, item) => {
          if (isActiveSipStatus(item.sipStatus)) {
            acc.totalAmount += Number(item.installmentAmt) || 0
            acc.totalSIPCount += 1
          }
          return acc
        },
        { totalAmount: 0, totalSIPCount: 0 },
      )
  }

  const getCancelledSipsInfo = (sips = []) => {
    return sips
      ?.filter((sip) => sip.customerBasketInvestmentId !== null)
      ?.reduce(
        (acc, item) => {
          if (isInactiveSipStatus(item.sipStatus)) {
            acc.totalAmount += Number(item.installmentAmt) || 0
            acc.totalSIPCount += 1
          }
          return acc
        },
        { totalAmount: 0, totalSIPCount: 0 },
      )
  }

  const getSipOverallStatus = (sips) => {
    const activeSipCount = sips?.reduce(
      (acc, sip) => (isActiveSipStatus(sip.sipStatus) ? acc + 1 : acc),
      0,
    )

    if (activeSipCount === sips.length) {
      return 'Active'
    } else if (activeSipCount === 0) {
      return 'Cancelled'
    } else {
      return 'Partial'
    }
  }

  const getSipSortTime = (sip = {}) =>
    Math.max(
      parseSipDate(sip?.sipStartDate),
      parseSipDate(sip?.createdDate),
      parseSipDate(sip?.sipRegDate),
      parseSipDate(sip?.cancelledDate),
      parseSipDate(sip?.updatedDate),
    )

  const getBasketGroupDate = (basketSips = []) =>
    (basketSips || []).reduce((latest, sip) => {
      const sipTime = getSipSortTime(sip)
      return sipTime > latest ? sipTime : latest
    }, 0)

  const sortBasketGroupsByDateDesc = (groupedSips = {}) =>
    Object.entries(groupedSips || {})
      .map(([basketId, basketSips]) => [
        basketId,
        [...(basketSips || [])].sort((a, b) => getSipSortTime(b) - getSipSortTime(a)),
      ])
      .sort(([, sipsA], [, sipsB]) => getBasketGroupDate(sipsB) - getBasketGroupDate(sipsA))

  const isTimeOlderThanSixMonths = (time) => {
    if (!time) return false
    const sixMonthsAgo = new Date()
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6)
    return time < sixMonthsAgo.getTime()
  }

  const sortedActiveGroups = sortBasketGroupsByDateDesc(activeSips)
  const sortedInProgressGroups = sortBasketGroupsByDateDesc(inProgressSips)
  const sortedCancelledGroups = sortBasketGroupsByDateDesc(cancelledSips)
  const recentInactiveGroups = sortedCancelledGroups.filter(
    ([, basketSips]) => !isTimeOlderThanSixMonths(getBasketGroupDate(basketSips)),
  )
  const olderInactiveGroups = sortedCancelledGroups.filter(([, basketSips]) =>
    isTimeOlderThanSixMonths(getBasketGroupDate(basketSips)),
  )
  const initialOlderInactiveCount = recentInactiveGroups.length > 0 ? 0 : INACTIVE_PAGE_SIZE
  const effectiveOlderInactiveCount = Math.max(
    visibleOlderInactiveCount,
    initialOlderInactiveCount,
  )
  const visibleCancelledGroups = [
    ...recentInactiveGroups,
    ...olderInactiveGroups.slice(0, effectiveOlderInactiveCount),
  ]
  const hasMoreOlderInactive = effectiveOlderInactiveCount < olderInactiveGroups.length

  const handleLoadMoreInactive = () => {
    if (loadingMoreInactive || !hasMoreOlderInactive) return

    setLoadingMoreInactive(true)
    window.setTimeout(() => {
      setVisibleOlderInactiveCount((prev) => {
        const current = Math.max(prev, initialOlderInactiveCount)
        return Math.min(current + INACTIVE_PAGE_SIZE, olderInactiveGroups.length)
      })
      setLoadingMoreInactive(false)
    }, 350)
  }

  const renderInactiveLoadMore = () => {
    if (!hasMoreOlderInactive) return null

    return (
      <div className='px-4 py-6 lg:px-0'>
        {loadingMoreInactive && (
          <div className='mb-4 space-y-3' aria-hidden='true'>
            {[1, 2].map((item) => (
              <div key={item} className='flex items-center justify-between p-4'>
                <div className='flex items-center gap-4'>
                  <Skeleton className='h-12 w-12 rounded-[8px]' />
                  <div className='space-y-2'>
                    <Skeleton className='h-4 w-48' />
                    <Skeleton className='h-4 w-20' />
                  </div>
                </div>
                <Skeleton className='h-9 w-20 rounded-md' />
              </div>
            ))}
          </div>
        )}
        <div className='flex justify-center'>
          <Button
            variant='outline'
            className='min-w-[140px]'
            loading={loadingMoreInactive}
            onClick={handleLoadMoreInactive}
          >
            Load more
          </Button>
        </div>
      </div>
    )
  }

  if (sips.contents.length === 0) {
    return (
      <SIPsEmpty
        title='There are no active basket SIPs right now.'
        description='Start your investment journey today by choosing a plan or exploring our curated funds.'
        mainText='Active Basket SIPs'
        page='/dashboard/mutual-funds'
        showButton={false}
        variant='active'
      />
    )
  }

  switch (sips.state) {
    case 'loading':
      return (
        <div className='max-w-[1128px] mx-auto'>
          <MFOrdersSkeleton />
        </div>
      )

    case 'hasValue':
      return (
        <>
          <div className='fabits-dark-section min-h-screen bg-white'>
            {sips?.contents?.message?.toLowerCase() === 'no sip found for the specified user.' ? (
              <SIPsEmpty
                title='There are no active basket SIPs right now.'
                description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                mainText='Active Basket SIPs'
                page='/dashboard/mutual-funds'
                showButton={false}
                variant='active'
              />
            ) : (
              <>
                <div className='mb-4 px-4 lg:px-0'>
                  <div className='mt-4 w-full rounded-lg border border-black-100 bg-white px-4 py-4 shadow-[0_8px_24px_rgba(4,3,19,0.05)] lg:mx-auto lg:max-w-2xl lg:px-6'>
                    <div className='grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-4 sm:gap-6'>
                      <div className='min-w-0 space-y-1'>
                        <p className='truncate text-base font-semibold text-black-500 sm:text-lg'>
                          {getActiveSipsInfo(sips?.contents?.data)?.totalSIPCount}
                        </p>

                        <p className='text-xs font-medium leading-4 text-black-400 sm:text-sm'>
                          No. of active SIPs
                        </p>
                      </div>
                      <Separator orientation='vertical' className='h-11' />

                      <div className='min-w-0 space-y-1 text-right'>
                        <p className='truncate text-base font-semibold text-black-500 sm:text-lg'>
                          ₹ {toCurrency(getActiveSipsInfo(sips?.contents?.data)?.totalAmount)}
                        </p>

                        <p className='text-xs font-medium leading-4 text-black-400 sm:text-sm'>
                          Active SIP amount
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='flex justify-center items-center w-full flex-col gap-4'>
                  <Tabs defaultValue='active' className='w-full'>
                    <div className='flex items-center justify-center px-4 lg:px-0'>
                      <TabsList className='grid h-11 w-full max-w-[420px] grid-cols-3 rounded-full md:w-auto'>
                        <TabsTrigger
                          value='active'
                          className='h-9 px-1.5 text-[10px] leading-4 sm:text-sm md:px-4'
                        >
                          Active ({getActiveSipsInfo(sips?.contents?.data)?.totalSIPCount})
                        </TabsTrigger>
                        <TabsTrigger
                          value='in-progress'
                          className='h-9 px-1.5 text-[10px] leading-4 sm:text-sm md:px-4'
                        >
                          In-Progress ({inProgressSipsCount})
                        </TabsTrigger>
                        <TabsTrigger
                          value='cancelled'
                          className='h-9 px-1.5 text-[10px] leading-4 sm:text-sm md:px-4'
                        >
                          Inactive ({getCancelledSipsInfo(sips?.contents?.data)?.totalSIPCount})
                        </TabsTrigger>
                      </TabsList>
                    </div>
                    <TabsContent value='active' className='w-full'>
                      <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
                        {activeSips && Object.keys(activeSips).length > 0 ? (
                          <>
                            <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
                              <div className='text-primary-400 text-sm font-medium py-3'>
                                Goal Name
                              </div>

                              <div className='text-primary-400 text-sm font-medium py-3 px-4 pr-20'>
                                Amount
                              </div>
                            </div>

                            <Accordion
                              type='single'
                              collapsible
                              className='w-full fabits-compact-card-stack'
                            >
                              {sortedActiveGroups.map(([basketId, sips]) => (
                                <AccordionItem
                                  value={basketId}
                                  key={basketId}
                                  className='border-black-100 last:border-b-0'
                                >
                                  <AccordionTrigger className='py-3 hover:no-underline'>
                                    <div className='flex justify-between items-center w-full'>
                                      <div className='w-full'>
                                        <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                                          <img
                                            src={basketRowIcon}
                                            className='fabits-basket-row-icon'
                                            alt=''
                                            aria-hidden='true'
                                          />
                                          <div className='w-full min-w-0'>
                                            <div className='flex justify-between gap-x-4 items-center'>
                                              <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                                <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                                  {sips[0]?.customerBasketName}
                                                </span>
                                              </p>
                                            </div>

                                            <p className='text-sm text-black-400'>
                                              Repeats on the{' '}
                                              <strong>
                                                {addNumberSuffix(getDate(sips[0]?.sipStartDate))}
                                              </strong>{' '}
                                              of every month
                                            </p>

                                            <div className='flex justify-between items-center'>
                                              <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                                Start Date -
                                                <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                                  <span className='font-semibold'>
                                                    {getDate(sips[0]?.sipStartDate)}
                                                  </span>
                                                  <span className='font-semibold'>
                                                    {
                                                      monthShortNames[
                                                      getMonth(sips[0]?.sipStartDate) - 1
                                                      ]
                                                    }
                                                  </span>
                                                  <span className='font-semibold'>
                                                    {getYear(sips[0]?.sipStartDate)}
                                                  </span>
                                                </p>
                                              </div>

                                              <p className='text-nowrap pr-2 md:hidden'>
                                                ₹ {toCurrency(getTotalAmount(sips))}
                                              </p>
                                            </div>
                                          </div>

                                          <div className='hidden md:flex items-center gap-x-2 shrink-0'>
                                            <p className='text-nowrap pr-2 font-semibold text-gray-900'>
                                              ₹ {toCurrency(getTotalAmount(sips))}
                                            </p>
                                          </div>

                                          <Menubar className='shrink-0'>
                                            <MenubarMenu>
                                              <MenubarTrigger
                                                onClick={(e) => e.stopPropagation()}
                                                className='bg-transparent hover:bg-[#F4F7FE] px-1 py-[10px] rounded-full h-6 w-6 md:h-10 md:w-7 flex justify-center items-center cursor-pointer'
                                              >
                                                <MoreVerticalIcon className='h-4 w-4' />
                                              </MenubarTrigger>
                                              <MenubarContent
                                                side='left'
                                                alignOffset={8}
                                                className='rounded-[10px] flex flex-col gap-y-1'
                                                onCloseAutoFocus={(e) => e.preventDefault()}
                                                onEscapeKeyDown={(e) => e.stopPropagation()}
                                              >
                                                <MenubarItem
                                                  className='pl-2 text-sm text-black-500 bg-gray-50 cursor-pointer hover:bg-gray-100'
                                                  onSelect={(e) => {
                                                    e.preventDefault()
                                                    setSelectedSIPUpdate(sips)
                                                    setShowSIPUpdate(true)
                                                    setOtpActionType('update')
                                                  }}
                                                >
                                                  Update SIP
                                                </MenubarItem>

                                                <MenubarItem
                                                  className='pl-2 text-sm text-ellipsis text-black-500 bg-gray-50 cursor-pointer hover:bg-gray-100'
                                                  onSelect={(e) => {
                                                    e.preventDefault()
                                                    setSelectedSIP(sips)
                                                    setOtpActionType('cancel')
                                                    setShowSIPCancel(true)
                                                  }}
                                                >
                                                  Cancel SIP
                                                </MenubarItem>
                                              </MenubarContent>
                                            </MenubarMenu>
                                          </Menubar>
                                        </div>
                                      </div>
                                    </div>
                                  </AccordionTrigger>

                                  <AccordionContent>
                                    <div>
                                      {sips?.map((sip, index) => {
                                        return (
                                          <div
                                            className={`p-4 flex items-center lg:items-start w-full`}
                                            key={index}
                                          >
                                            <div className='flex justify-between items-center w-full'>
                                              <div className='flex justify-between items-center w-full'>
                                                <div className='w-full flex justify-between items-center gap-x-2'>
                                                  <div className='flex gap-x-4 items-center md:w-[50%]'>
                                                    <img
                                                      src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                                      className='h-12 w-12 rounded-[8px] mt-1'
                                                    />
                                                    <div className='w-full md:w-auto'>
                                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                        {sip?.sname
                                                          ? sip.sname
                                                          : sip?.amfiName
                                                            ? sip.amfiName
                                                            : sip?.schemeName}
                                                        <span
                                                          className={`text-sm ${capitalizeWords(sip?.sipStatus) ===
                                                            'Active'
                                                            ? 'text-secondary-500 bg-secondary-50 rounded-full px-2'
                                                            : capitalizeWords(sip?.sipStatus) ===
                                                              'Cancelled'
                                                              ? 'text-error-500 bg-error-50 rounded-full px-2'
                                                              : 'text-warning-500 bg-warning-50 rounded-full px-2'
                                                            }`}
                                                        >
                                                          {getSipStatusLabel(sip?.sipStatus)}
                                                        </span>{' '}
                                                      </p>
                                                    </div>
                                                  </div>

                                                  {sip?.installmentAmt && (
                                                    <p className='text-nowrap text-sm font-medium text-black-400 pr-16'>
                                                      {calculateParcentage(
                                                        sip?.installmentAmt,
                                                        getTotalAmount(sips),
                                                      )}{' '}
                                                      %
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                              {/* <div className='ml-4'>
                                              <Menubar className='border-0 bg-transparent p-0'>
                                                <MenubarMenu>
                                                  <MenubarTrigger asChild>
                                                    <Button
                                                      variant='ghost'
                                                      size='sm'
                                                      className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        setOpenMenubar(
                                                          openMenubar === sip.id ? null : sip.id,
                                                        )
                                                      }}
                                                    >
                                                      <MoreVerticalIcon className='h-4 w-4' />
                                                    </Button>
                                                  </MenubarTrigger>
                                                  <MenubarContent align='end' className='w-48'>
                                                    <MenubarItem
                                                      className='text-error-500 bg-error-50 cursor-pointer'
                                                      onClick={() => {
                                                        setShowSIPCancel(true), setSelectedSIP(sip)
                                                      }}
                                                    >
                                                      Cancel SIP
                                                    </MenubarItem>
                                                  </MenubarContent>
                                                </MenubarMenu>
                                              </Menubar>
                                            </div> */}
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </AccordionContent>
                                </AccordionItem>
                              ))}
                            </Accordion>

                            <p className='text-sm text-black-400 text-center mt-4'>
                              Tap the three dots to Cancel or Update your SIPs
                            </p>
                          </>
                        ) : (
                          <SIPsEmpty
                            title='There are no active basket SIPs right now.'
                            description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                            mainText='Active Basket SIPs'
                            page='/dashboard/mutual-funds'
                            showButton={false}
                            variant='active'
                          />
                        )}
                      </div>
                    </TabsContent>
                    <TabsContent value='in-progress'>
                      <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
                        {inProgressSips && Object.keys(inProgressSips).length > 0 ? (
                          <>
                            <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
                              <div className='text-primary-400 text-sm font-medium py-3'>
                                Goal Name
                              </div>

                              <div className='text-primary-400 text-sm font-medium py-3 px-4'>
                                Amount
                              </div>
                            </div>
                            <Accordion
                              type='single'
                              collapsible
                              className='w-full fabits-compact-card-stack'
                            >
                              {sortedInProgressGroups.map(([basketId, sips]) => (
                                <AccordionItem
                                  value={basketId}
                                  key={basketId}
                                  className='border-black-100 last:border-b-0'
                                >
                                  <AccordionTrigger className='py-3 hover:no-underline'>
                                    <div className='flex justify-between items-center w-full'>
                                      <div className='w-full'>
                                        <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                                          <img
                                            src={basketRowIcon}
                                            className='fabits-basket-row-icon'
                                            alt=''
                                            aria-hidden='true'
                                          />
                                          <div className='w-full'>
                                            <div className='flex justify-between gap-x-4 items-center'>
                                              <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                                <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                                  {' '}
                                                  {sips[0]?.customerBasketName}
                                                </span>
                                              </p>
                                            </div>

                                            <p className='text-sm text-black-400'>
                                              Repeats on the{' '}
                                              <strong>
                                                {addNumberSuffix(getDate(sips[0]?.startDate))}
                                              </strong>{' '}
                                              of every month
                                            </p>

                                            <div className='flex justify-between items-center'>
                                              <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                                Start Date -
                                                <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                                  <span className='font-semibold'>
                                                    {getDate(sips[0]?.startDate)}
                                                  </span>
                                                  <span className='font-semibold '>
                                                    {
                                                      monthShortNames[
                                                      getMonth(sips[0]?.startDate) - 1
                                                      ]
                                                    }
                                                  </span>
                                                  <span className='font-semibold '>
                                                    {getYear(sips[0]?.startDate)}
                                                  </span>
                                                </p>
                                              </div>

                                              <p className='text-nowrap pr-2 md:hidden'>
                                                ₹ {toCurrency(getTotalAmount(sips))}
                                              </p>
                                            </div>
                                          </div>

                                          <div className='hidden md:flex'>
                                            <p className='text-nowrap pr-2'>
                                              ₹ {toCurrency(getTotalAmount(sips))}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </AccordionTrigger>

                                  <AccordionContent>
                                    <div>
                                      {sips?.map((sip, index) => {
                                        return (
                                          <div
                                            className={`p-4 flex items-center lg:items-start w-full`}
                                            key={index}
                                          >
                                            <div className='flex justify-between items-center w-full'>
                                              <div className='flex justify-between items-center w-full'>
                                                <div className='w-full flex justify-between items-center gap-x-2'>
                                                  <div className='flex gap-x-4 items-center md:w-[50%]'>
                                                    <img
                                                      src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                                      className='h-12 w-12 rounded-[8px] mt-1'
                                                    />
                                                    <div className='w-full md:w-auto'>
                                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                        {sip?.sname
                                                          ? sip.sname
                                                          : sip?.amfiName
                                                            ? sip.amfiName
                                                            : sip?.schemeName}
                                                      </p>
                                                    </div>
                                                  </div>

                                                  {sip?.installmentAmount && (
                                                    <p className='text-nowrap text-sm font-medium text-black-400'>
                                                      {calculateParcentage(
                                                        sip?.installmentAmount,
                                                        getTotalAmount(sips),
                                                      )}{' '}
                                                      %
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                              {/* <div className='ml-4'>
                                              <Menubar className='border-0 bg-transparent p-0'>
                                                <MenubarMenu>
                                                  <MenubarTrigger asChild>
                                                    <Button
                                                      variant='ghost'
                                                      size='sm'
                                                      className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        setOpenMenubar(
                                                          openMenubar === sip.id ? null : sip.id,
                                                        )
                                                      }}
                                                    >
                                                      <MoreVerticalIcon className='h-4 w-4' />
                                                    </Button>
                                                  </MenubarTrigger>
                                                  <MenubarContent align='end' className='w-48'>
                                                    <MenubarItem
                                                      className='text-error-500 bg-error-50 cursor-pointer'
                                                      onClick={() => {
                                                        setShowSIPCancel(true), setSelectedSIP(sip)
                                                      }}
                                                    >
                                                      Cancel SIP
                                                    </MenubarItem>
                                                  </MenubarContent>
                                                </MenubarMenu>
                                              </Menubar>
                                            </div> */}
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </AccordionContent>
                                </AccordionItem>
                              ))}
                            </Accordion>
                          </>
                        ) : (
                          <SIPsEmpty
                            title='There are no basket SIPs in progress right now.'
                            description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                            mainText='In-Progress Basket SIPs'
                            page='/dashboard/mutual-funds'
                            showButton={false}
                            variant='inProgress'
                          />
                        )}
                      </div>
                    </TabsContent>

                    <TabsContent value='cancelled'>
                      <div className='max-w-[1128px] px-4 lg:px-0 mx-auto'>
                        {cancelledSips && Object.keys(cancelledSips).length > 0 ? (
                          <>
                            <div className='hidden md:flex justify-between bg-[#F4F7FE] rounded-lg pl-14'>
                              <div className='text-primary-400 text-sm font-medium py-3'>
                                Goal Name
                              </div>

                              <div className='text-primary-400 text-sm font-medium py-3 px-4'>
                                Amount
                              </div>
                            </div>
                            <Accordion
                              type='single'
                              collapsible
                              className='w-full fabits-compact-card-stack'
                            >
                              {visibleCancelledGroups.map(([basketId, sips]) => (
                                <AccordionItem
                                  value={basketId}
                                  key={basketId}
                                  className='border-black-100 last:border-b-0'
                                >
                                  <AccordionTrigger className='py-3 hover:no-underline'>
                                    <div className='flex justify-between items-center w-full'>
                                      <div className='w-full'>
                                        <div className='w-full flex md:justify-between items-start md:items-center gap-x-2'>
                                          <img
                                            src={basketRowIcon}
                                            className='fabits-basket-row-icon'
                                            alt=''
                                            aria-hidden='true'
                                          />
                                          <div className='w-full'>
                                            <div className='flex justify-between gap-x-4 items-center'>
                                              <p className='font-semibold text-gray-900 text-wrap leading-6 flex items-center gap-x-2'>
                                                <span className='truncate whitespace-nowrap overflow-hidden max-w-[200px] md:max-w-max'>
                                                  {' '}
                                                  {sips[0]?.customerBasketName}
                                                </span>
                                              </p>
                                            </div>

                                            <p className='text-sm text-black-400'>
                                              Repeats on the{' '}
                                              <strong>
                                                {addNumberSuffix(getDate(sips[0]?.sipStartDate))}
                                              </strong>{' '}
                                              of every month
                                            </p>

                                            <div className='flex justify-between items-center'>
                                              <div className='flex gap-x-1 text-xs items-center text-black-400'>
                                                Start Date -
                                                <p className='flex justify-start text-xs items-center gap-x-1 text-center font-DMSans'>
                                                  <span className='font-semibold'>
                                                    {getDate(sips[0]?.sipStartDate)}
                                                  </span>
                                                  <span className='font-semibold '>
                                                    {
                                                      monthShortNames[
                                                      getMonth(sips[0]?.sipStartDate) - 1
                                                      ]
                                                    }
                                                  </span>
                                                  <span className='font-semibold '>
                                                    {getYear(sips[0]?.sipStartDate)}
                                                  </span>
                                                </p>
                                              </div>

                                              <p className='text-nowrap pr-2 md:hidden'>₹ 0</p>
                                            </div>
                                          </div>

                                          <div className='hidden md:flex'>
                                            <p className='text-nowrap pr-2'>
                                              {/* ₹ {toCurrency(getTotalAmount(sips))} */}₹ 0
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* <Menubar className='shrink-0'>
                                      <MenubarMenu>
                                        <MenubarTrigger
                                          onClick={(e) => e.stopPropagation()}
                                          className='bg-transparent hover:bg-[#F4F7FE] px-1 py-[10px] rounded-full h-6 w-6 md:h-10 md:w-7 flex justify-center items-center cursor-pointer'
                                        >
                                          <MoreVerticalIcon className='h-4 w-4' />
                                        </MenubarTrigger>
                                        <MenubarContent
                                          side='left'
                                          alignOffset={8}
                                          className='rounded-[10px] flex flex-col gap-y-1'
                                          onCloseAutoFocus={(e) => e.preventDefault()}
                                          onEscapeKeyDown={(e) => e.stopPropagation()}
                                        >
                                          <MenubarItem
                                            className='pl-2 text-sm text-warning-500 bg-warning-50 cursor-pointer hover:bg-warning-100'
                                            onSelect={(e) => {
                                              e.preventDefault()
                                              setSelectedSIPUpdate(sips)
                                              setShowSIPUpdate(true)
                                              setOtpActionType('restart')
                                            }}
                                          >
                                            Restart SIP
                                          </MenubarItem>
                                        </MenubarContent>
                                      </MenubarMenu>
                                    </Menubar> */}
                                  </AccordionTrigger>

                                  <AccordionContent>
                                    <div>
                                      {sips?.map((sip, index) => {
                                        return (
                                          <div
                                            className={`p-4 flex items-center lg:items-start w-full`}
                                            key={index}
                                          >
                                            <div className='flex justify-between items-center w-full'>
                                              <div className='flex justify-between items-center w-full'>
                                                <div className='w-full flex justify-between items-center gap-x-2'>
                                                  <div className='flex gap-x-4 items-center md:w-[50%]'>
                                                    <img
                                                      src={`${env.MF_LOGOS_URL}/${sip?.amcCode}.png`}
                                                      className='h-12 w-12 rounded-[8px] mt-1'
                                                    />
                                                    <div className='w-full md:w-auto'>
                                                      <p className='font-semibold text-gray-900  md:max-w-full text-wrap leading-6'>
                                                        {sip?.sname
                                                          ? sip.sname
                                                          : sip?.amfiName
                                                            ? sip.amfiName
                                                            : sip?.schemeName}
                                                        <span className='ml-2 text-sm text-error-500 bg-error-50 rounded-full px-2'>
                                                          {getSipStatusLabel(sip?.sipStatus)}
                                                        </span>
                                                      </p>
                                                    </div>
                                                  </div>

                                                  {/* {sip?.installmentAmt && (
                                                    <p className='text-nowrap text-sm font-medium text-black-400'>
                                                      {calculateParcentage(
                                                        sip?.installmentAmt,
                                                        getTotalAmount(sips),
                                                      )}{' '}
                                                      %
                                                    </p>
                                                  )} */}
                                                </div>
                                              </div>
                                              {/* <div className='ml-4'>
                                              <Menubar className='border-0 bg-transparent p-0'>
                                                <MenubarMenu>
                                                  <MenubarTrigger asChild>
                                                    <Button
                                                      variant='ghost'
                                                      size='sm'
                                                      className='h-6 w-6 p-0 rounded-full hover:bg-gray-100 cursor-pointer'
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        setOpenMenubar(
                                                          openMenubar === sip.id ? null : sip.id,
                                                        )
                                                      }}
                                                    >
                                                      <MoreVerticalIcon className='h-4 w-4' />
                                                    </Button>
                                                  </MenubarTrigger>
                                                  <MenubarContent align='end' className='w-48'>
                                                    <MenubarItem
                                                      className='text-error-500 bg-error-50 cursor-pointer'
                                                      onClick={() => {
                                                        setShowSIPCancel(true), setSelectedSIP(sip)
                                                      }}
                                                    >
                                                      Cancel SIP
                                                    </MenubarItem>
                                                  </MenubarContent>
                                                </MenubarMenu>
                                              </Menubar>
                                            </div> */}
                                            </div>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </AccordionContent>
                                </AccordionItem>
                              ))}
                            </Accordion>
                            {renderInactiveLoadMore()}
                          </>
                        ) : (
                          <SIPsEmpty
                            title='There are no inactive basket SIPs right now.'
                            description='Start your investment journey today by choosing a plan or exploring our curated funds.'
                            mainText='Inactive Basket SIPs'
                            page='/dashboard/mutual-funds'
                            showButton={false}
                            variant='inactive'
                          />
                        )}
                      </div>
                    </TabsContent>
                  </Tabs>
                </div>

                <Dialog open={showSIPCancel} onOpenChange={setShowSIPCancel}>
                  <DialogContent className='sm:max-w-md' showclose={true}>
                    <DialogHeader className='text-center space-y-4'>
                      <DialogTitle className='text-xl text-center font-normal text-black-400'>
                        Your SIP of ₹{' '}
                        <strong>
                          {toCurrency(
                            selectedSIP
                              ?.map(
                                (sip) =>
                                  Number(sip.installmentAmt) || Number(sip.installmentAmount) || 0,
                              )
                              .reduce((acc, curr) => acc + curr, 0),
                          )}
                        </strong>{' '}
                        will be cancelled
                      </DialogTitle>
                    </DialogHeader>

                    <div className='space-y-6 pt-4'>
                      <div className='space-y-3'>
                        <label className='text-base font-medium text-gray-900'>
                          Reason for cancellation
                        </label>
                        <Select value={selectedReason} onValueChange={setSelectedReason}>
                          <SelectTrigger className='w-full h-12 text-gray-500 border'>
                            <SelectValue placeholder='Select a reason' />
                          </SelectTrigger>
                          <SelectContent className='z-[10000]'>
                            {cancellationReasons.map((reason) => (
                              <SelectItem
                                key={reason.code}
                                value={reason.code}
                                className='py-3 cursor-pointer text-black-500 text-sm hover:bg-gray-50'
                              >
                                {reason.description}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>

                      <div className='flex gap-3 pt-4'>
                        <Button
                          variant='outline'
                          className='flex-1'
                          onClick={() => setShowSIPCancel(false)}
                          disabled={loading}
                        >
                          Keep SIP
                        </Button>
                        <Button
                          className='flex-1 bg-primary-600'
                          onClick={generateOTP}
                          disabled={!selectedReason}
                          loading={loading}
                        >
                          Cancel SIP
                        </Button>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>

                {isDesktop ? (
                  <Dialog
                    open={showSIPUpdate}
                    onOpenChange={(open) => {
                      setShowSIPUpdate(open)
                      if (!open) {
                        if (skipAmountResetRef.current) {
                          skipAmountResetRef.current = false
                          return
                        }
                        // Reset amount when dialog closes
                        setSelectedAmount('')
                        setSelectedAmountDisplay('')
                      } else {
                        // Set initial value when dialog opens
                        const currentAmount =
                          selectedSIPUpdate
                            ?.map(
                              (sip) =>
                                Number(sip.installmentAmt) || Number(sip.installmentAmount) || 0,
                            )
                            .reduce((acc, curr) => acc + curr, 0) || 0
                        if (currentAmount > 0) {
                          setSelectedAmount(currentAmount)
                          setSelectedAmountDisplay(formatIndianCurrency(currentAmount.toString()))
                        }
                      }
                    }}
                  >
                    <DialogContent className='sm:max-w-md' showclose={true}>
                      <DialogHeader className='text-center space-y-4'>
                        <DialogTitle className='text-xl text-center font-normal text-black-400'>
                          You're about to modify your SIP. <br /> You'll now be investing ₹{' '}
                          <strong>{toCurrency(selectedAmount || 0)}</strong> every month.
                        </DialogTitle>
                      </DialogHeader>

                      <div className='space-y-6 pt-4'>
                        <div className='space-y-3'>
                          <label className='text-base font-medium text-gray-900'>
                            Enter SIP Amount
                          </label>
                          <Input
                            type='text'
                            placeholder='Enter the new amount'
                            value={selectedAmountDisplay}
                            startAdornment='₹'
                            onChange={handleSelectedAmountChange}
                          />
                        </div>

                        <div>
                          <Popover open={isDatePopoverOpen} onOpenChange={setIsDatePopoverOpen}>
                            <PopoverTrigger asChild>
                              <Button
                                variant={'outline'}
                                type='button'
                                className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between mx-auto'
                              >
                                <span className='text-primary-500 flex items-center gap-x-2'>
                                  <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                                  <p>
                                    SIP starts on -{' '}
                                    <b>
                                      {addNumberSuffix(sipDate.split('/')[0])}{' '}
                                      {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                                      {sipDate.split('/')[2]}
                                    </b>
                                  </p>
                                </span>

                                <Pen className='h-4 w-4 text-primary-500' />
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent
                              className='p-0 w-auto rounded-full z-[10001]'
                              align='center'
                              side='top'
                            >
                              <div className='flex gap-x-2 p-2'>
                                {sipDates.map((day, index) => (
                                  <Button
                                    key={(day + index).toString()}
                                    type='button'
                                    className={`h-8 w-8 rounded-full inline-block ${selectedDay !== +day
                                      ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                                      : 'text-white'
                                      }`}
                                    size='simple'
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setSelectedDay(+day)
                                      setIsDatePopoverOpen(false)
                                    }}
                                  >
                                    {day}
                                  </Button>
                                ))}
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>

                        <div className='flex gap-3'>
                          <Button
                            className='flex-1 bg-primary-600 disabled:bg-primary-300'
                            onClick={openSipUpdateBreakdown}
                            disabled={!selectedAmount || Number(selectedAmount) <= 0}
                            loading={loading}
                          >
                            View Breakdown
                          </Button>
                        </div>
                      </div>
                    </DialogContent>
                  </Dialog>
                ) : (
                  <Sheet
                    open={showSIPUpdate}
                    onOpenChange={(open) => {
                      setShowSIPUpdate(open)
                      if (!open) {
                        if (skipAmountResetRef.current) {
                          skipAmountResetRef.current = false
                          return
                        }
                        // Reset amount when sheet closes
                        setSelectedAmount('')
                        setSelectedAmountDisplay('')
                      } else {
                        // Set initial value when sheet opens
                        const currentAmount =
                          selectedSIPUpdate
                            ?.map(
                              (sip) =>
                                Number(sip.installmentAmt) || Number(sip.installmentAmount) || 0,
                            )
                            .reduce((acc, curr) => acc + curr, 0) || 0
                        if (currentAmount > 0) {
                          setSelectedAmount(currentAmount)
                          setSelectedAmountDisplay(formatIndianCurrency(currentAmount.toString()))
                        }
                      }
                    }}
                  >
                    <SheetContent
                      side='bottom'
                      className='rounded-t-3xl font-DMSans max-h-[90vh] overflow-y-auto'
                    >
                      <SheetHeader>
                        <SheetTitle className='text-xl text-center font-normal text-black-400'>
                          You're about to modify your SIP. <br /> You'll now be investing ₹{' '}
                          <strong>{toCurrency(selectedAmount || 0)}</strong> every month.
                        </SheetTitle>
                      </SheetHeader>

                      <div className='space-y-4 pt-4'>
                        <div className='space-y-2'>
                          <label className='text-base font-medium text-gray-900'>Edit Amount</label>
                          <Input
                            type='text'
                            placeholder='Enter the new amount'
                            value={selectedAmountDisplay}
                            startAdornment='₹'
                            onChange={handleSelectedAmountChange}
                          />
                        </div>

                        <div className='space-y-2'>
                          <label className='text-base font-medium text-gray-900'>
                            Select SIP Date
                          </label>

                          <Popover open={isDatePopoverOpen} onOpenChange={setIsDatePopoverOpen}>
                            <PopoverTrigger asChild>
                              <Button
                                variant={'outline'}
                                type='button'
                                className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between mx-auto'
                              >
                                <span className='text-primary-500 flex items-center gap-x-2'>
                                  <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                                  <p>
                                    SIP starts on -{' '}
                                    <b>
                                      {addNumberSuffix(sipDate.split('/')[0])}{' '}
                                      {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                                      {sipDate.split('/')[2]}
                                    </b>
                                  </p>
                                </span>

                                <Pen className='h-4 w-4 text-primary-500' />
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent
                              className='p-0 w-auto rounded-full z-[10001]'
                              align='center'
                              side='top'
                            >
                              <div className='flex gap-x-2 p-2'>
                                {sipDates.map((day, index) => (
                                  <Button
                                    key={(day + index).toString()}
                                    type='button'
                                    className={`h-8 w-8 rounded-full inline-block ${selectedDay !== +day
                                      ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                                      : 'text-white'
                                      }`}
                                    size='simple'
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setSelectedDay(+day)
                                      setIsDatePopoverOpen(false)
                                    }}
                                  >
                                    {day}
                                  </Button>
                                ))}
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>

                        <div className='flex gap-3'>
                          <Button
                            className='flex-1 bg-primary-600 disabled:bg-primary-300'
                            onClick={openSipUpdateBreakdown}
                            disabled={!selectedAmount || Number(selectedAmount) <= 0}
                            loading={loading}
                          >
                            View Breakdown
                          </Button>
                        </div>
                      </div>
                    </SheetContent>
                  </Sheet>
                )}
              </>
            )}
          </div>

          <OrderOtpVerification
            phoneNumber={userDetails?.phoneNumber}
            openOTPPopup={openOTPPopup}
            setOpenOTPPopup={(open) => {
              setOpenOTPPopup(open)
              if (!open) {
                // Reset action type when OTP popup closes
                setOtpActionType(null)
              }
            }}
            email={userDetails?.email}
            handleSipOrOT={
              otpActionType === 'update'
                ? handleSIPUpdate
                : otpActionType === 'restart'
                  ? handleSIPRestart
                  : handleSIPCancel
            }
          />
        </>
      )

    case 'hasError':
      return (
        <div className='fabits-dark-section flex items-center justify-center bg-white'>
          <ApiErrorState />
        </div>
      )

    default:
      return null
  }
}

export default BasketSIPs
